export default "__VITE_ASSET__DjzD7wL7__"